import { white } from "colors";

export enum AvailableThemes {
  Ezzebank = "Ezzebank",
  Banprime = "Banprime",
  Hubchain = "Hubchain",
  GrooveBank = "GrooveBank",
}

export interface TenantConfigThemeFieldBasicAttributes {
  dark: boolean;
  color?: string;
  class?: string;
  svgFill?: string;
  bgColor?: string;
  textColor?: string;
}
export interface TenantConfigItensFooter {
  emailSac: string;
  emailOmbudsman: string;
  linkPrivacy: string;
  linkTerms: string;
  linkDevelopers: string;
  linkSocialInstagram: string;
  linkSocialFacebook: string;
  linkSocialTwitterX: string;
}

export interface TenantConfigTheme {
  dark: boolean;
  text: {
    primary: TenantConfigThemeFieldBasicAttributes;
    secondary: TenantConfigThemeFieldBasicAttributes;
  };
  vTextField: TenantConfigThemeFieldBasicAttributes;
  vBtn: TenantConfigThemeFieldBasicAttributes;
  vRadio: TenantConfigThemeFieldBasicAttributes;
  vSwitch: TenantConfigThemeFieldBasicAttributes;
  vAvatar: TenantConfigThemeFieldBasicAttributes;
  vAppBar: TenantConfigThemeFieldBasicAttributes;
  vAppBarMenu: TenantConfigThemeFieldBasicAttributes;
  vFooter: TenantConfigThemeFieldBasicAttributes;
  vFormLoginPage: TenantConfigThemeFieldBasicAttributes;
  a: TenantConfigThemeFieldBasicAttributes;
}

// @reference: https://vuetifyjs.com/en/styles/colors/#material-colors
export const TenantThemes: {
  [theme in AvailableThemes]: TenantConfigTheme;
} = {
  [AvailableThemes.Ezzebank]: {
    dark: true,
    text: {
      primary: {
        dark: true,
        color: "white--text",
      },
      secondary: {
        dark: true,
        color: "white--text",
      },
    },
    vTextField: {
      dark: true,
      color: "white",
    },
    vFormLoginPage: {
      dark: true,
      color: "pink accent-2",
      textColor: "white--text",
    },
    vBtn: {
      dark: true,
      color: "pink accent-2",
    },
    vRadio: {
      dark: true,
      color: "pink accent-2",
    },
    vSwitch: {
      dark: true,
      color: "pink accent-2",
    },
    vAvatar: {
      dark: true,
      color: "pink accent-2 white--text",
    },
    vAppBar: {
      dark: true,
      color: "white",
      bgColor: "pink accent-2",
    },
    vAppBarMenu: {
      dark: true,
      color: "pink accent-2",
      svgFill: "#6a1b9a",
      bgColor: "pink accent-2",
    },
    vFooter: {
      dark: false,
      color: "grey lighten-3",
      svgFill: "#6a1b9a",
      textColor: "purple--text text--darken-3",
      bgColor: "purple darken-3",
    },
    a: {
      dark: true,
      class: "mr-3 red--text",
    },
  },
  [AvailableThemes.Banprime]: {
    // Rosa vibrante (236, 28, 106) – Aproxima-se de "Pink 700" (#D81B60). pink-darken-1
    // Roxo escuro (98, 48, 147) – Aproxima-se de "Deep Purple 800" (#512DA8). deep-purple-darken-2
    dark: false,
    text: {
      primary: {
        dark: false,
        color: "black--text",
      },
      secondary: {
        dark: false,
        color: "black--text",
      },
    },
    vTextField: {
      dark: false,
      color: "black",
    },
    vFormLoginPage: {
      dark: true,
      color: "black",
    },
    vBtn: {
      dark: true,
      color: "pink accent-2",
    },
    vRadio: {
      dark: true,
      color: "pink accent-2",
    },
    vSwitch: {
      dark: true,
      color: "pink accent-2",
    },
    vAvatar: {
      dark: false,
      color: "deep-purple darken-2 white--text",
    },
    vAppBarMenu: {
      dark: true,
      color: "deep-purple darken-2",
      svgFill: "#512DA8",
      bgColor: "deep-purple--text text--darken-2",
    },
    vAppBar: {
      dark: true,
      color: "white",
      bgColor: "pink accent-2",
    },
    vFooter: {
      dark: false,
      color: "grey lighten-3",
      svgFill: "#6a1b9a",
      bgColor: "pink--text text--darken-2",
    },
    a: {
      dark: true,
      class: "mr-3 deep-purple--text",
    },
  },
  [AvailableThemes.Hubchain]: {
    // Azul escuro (58, 88, 155) – Aproxima-se de "Indigo 700" (#303F9F). indigo-darken-2
    // Azul ligeiramente mais claro (58, 85, 154) – Também se aproxima de "Indigo 700" (#303F9F). indigo-darken-2
    dark: false,
    text: {
      primary: {
        dark: false,
        color: "black--text",
      },
      secondary: {
        dark: false,
        color: "black--text",
      },
    },
    vTextField: {
      dark: false,
      color: "black",
    },
    vFormLoginPage: {
      dark: true,
      color: "black",
    },
    vBtn: {
      dark: true,
      color: "indigo darken-2",
    },
    vRadio: {
      dark: true,
      color: "indigo darken-2",
    },
    vSwitch: {
      dark: true,
      color: "indigo darken-2",
    },
    vAvatar: {
      dark: true,
      color: "indigo darken-2 white--text",
    },
    vAppBar: {
      dark: true,
      color: "white",
    },
    vAppBarMenu: {
      dark: true,
      color: "indigo darken-2",
      svgFill: "#303F9F",
    },
    vFooter: {
      dark: false,
      color: "grey lighten-3",
      svgFill: "#6a1b9a",
      bgColor: "indigo--text text--darken-2",
    },
    a: {
      dark: true,
      class: "mr-3 indigo--text",
    },
  },
  [AvailableThemes.GrooveBank]: {
    // Verde vibrante (93, 224, 5) – Aproxima-se de "Light Green A400" (#76FF03). light-green-accent-3
    dark: false,
    text: {
      primary: {
        dark: false,
        color: "black--text",
      },
      secondary: {
        dark: false,
        color: "black--text",
      },
    },
    vTextField: {
      dark: false,
      color: "black",
    },
    vFormLoginPage: {
      dark: false,
      color: "light-green accent-3",
    },
    vBtn: {
      dark: false,
      color: "light-green accent-3",
    },
    vRadio: {
      dark: true,
      color: "light-green accent-3",
    },
    vSwitch: {
      dark: true,
      color: "light-green accent-3",
    },
    vAvatar: {
      dark: true,
      color: "light-green darken-3 white--text",
    },
    vAppBar: {
      dark: true,
      color: "white",
    },
    vAppBarMenu: {
      dark: true,
      color: "light-green darken-3",
      svgFill: "#558B2F",
    },
    vFooter: {
      dark: false,
      color: "grey lighten-3",
      svgFill: "#6a1b9a",
      bgColor: "light-green darken-3",
    },
    a: {
      dark: true,
      class: "mr-3 green--text",
    },
  },
};
